import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  EMPTY_RESERVATIONS_REPORT_FILTERS,
  ReservationsReportFilterChip,
  ReservationsReportFilterOptions,
  ReservationsReportFiltersState
} from 'src/entities/order';

@Component({
  selector: 'app-reservations-report-filters',
  templateUrl: './reservations-report-filters.component.html',
  styleUrls: ['./reservations-report-filters.component.css']
})
export class ReservationsReportFiltersComponent {
  @Input() filters: ReservationsReportFiltersState = {
    ...EMPTY_RESERVATIONS_REPORT_FILTERS
  };
  @Input() filterOptions: ReservationsReportFilterOptions = {
    years: [],
    providers: [],
    reservationStatuses: [],
    orderStatuses: []
  };
  @Input() activeFilterChips: ReservationsReportFilterChip[] = [];
  @Input() disabled = false;

  @Output() filtersChange = new EventEmitter<ReservationsReportFiltersState>();
  @Output() clearAll = new EventEmitter<void>();
  @Output() removeFilter = new EventEmitter<ReservationsReportFilterChip['id']>();

  readonly trackByYear = (_: number, year: string) => year;
  readonly trackByProvider = (_: number, provider: string) => provider;
  readonly trackByStatus = (_: number, status: string) => status;
  readonly trackByChip = (_: number, chip: ReservationsReportFilterChip) =>
    chip.id;

  get hasActiveFilters(): boolean {
    return this.activeFilterChips.length > 0;
  }

  onFieldChange(patch: Partial<ReservationsReportFiltersState>): void {
    this.filtersChange.emit({
      ...this.filters,
      ...patch
    });
  }

  onSearchChange(value: string): void {
    this.onFieldChange({ searchValue: value ?? '' });
  }

  onYearChange(value: string | null): void {
    this.onFieldChange({ yearFile: value });
  }

  onProviderChange(value: string | null): void {
    this.onFieldChange({ providerName: value });
  }

  onReservationStatusChange(value: string | null): void {
    this.onFieldChange({ reservationStatus: value });
  }

  onOrderStatusChange(value: string | null): void {
    this.onFieldChange({ orderStatus: value });
  }
}
